// src/components/MenuMobile.jsx
import React, { useState } from 'react';
import { Drawer, Button, Menu, theme, Divider, Segmented } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { useLanguage } from '../../providers/LanguageProvider';
import LangSelect from './LangSelect';
import { SunOutlined, MoonOutlined } from '@ant-design/icons';

const { useToken } = theme;

const MenuMobile = ({ menuItems, onSelect, mode, setMode,lang,setLang }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { t } = useLanguage();
  const { token } = useToken();

  const handleMenuClick = (e) => {
    onSelect(e);
    setDrawerOpen(false); // Seçim yapıldığında çekmeceyi kapat
  };

  return (
    <div
      style={{
        height: 72,
        background: token.colorBgLayout,
        borderBottom: `1px solid ${token.colorBorder}`,
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px',
        position: 'sticky',
        top: 0,
        zIndex: 10,
      }}
    >
      <Button
        type="text"
        icon={<MenuOutlined />}
        size="large"
        onClick={() => setDrawerOpen(true)}
        style={{
          borderRadius: 999,
          width: 40,
          height: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      />
      <h3 style={{ margin: '0 0 0 16px' }}>{t('MY_ACCOUNT')}</h3>
      <Drawer
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src="https://customer.parts-soft.eu/static/media/logo.5ff8206924acc8ce74466cb6f7f31309.svg"
              alt="logo"
              style={{ width: 40, height: 40, borderRadius: 50, marginRight: 8 }}
            />
            My Account
          </div>
        }
        placement="left"
        closable={true}
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="inline"
          items={menuItems}
          onSelect={handleMenuClick}
          style={{ borderRight: 0 }}
        />
        <Divider />
        <div>
          <div style={{ padding: 16, display: 'flex', gap: 16, flexDirection: 'column', alignItems: 'center' }}>
            <LangSelect style={{ width: '100%' }} value={lang} onChange={setLang} />
            <Segmented
              size="large"
              value={mode}
              onChange={(v) => setMode(v)}
              options={[
                { label: <SunOutlined />, value: 'light' },
                { label: <MoonOutlined />, value: 'dark' },
              ]}
              style={{ borderRadius: 999 }}
            />
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default MenuMobile;